import { render, staticRenderFns } from "./common-dialog.vue?vue&type=template&id=2140bc4a&"
import script from "./common-dialog.vue?vue&type=script&lang=js&"
export * from "./common-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports